import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select"];
  static values = { accountId: Number };

  connect() {
    this.loadTemplates();
  }

  async loadTemplates() {
    try {
      const response = await fetch(`/accounts/${this.accountIdValue}/mautic_emails`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      const data = await response.json();

      if (!data.emails || data.emails.length === 0) {
        this.selectTarget.innerHTML = '<option value="">Nenhum template disponível</option>';
        return;
      }

      this.selectTarget.innerHTML =
        '<option value="">Selecione um template...</option>' +
        data.emails.map((email) => `<option value="${email.id}">${email.name}</option>`).join("");
    } catch (e) {
      this.selectTarget.innerHTML = '<option value="">Erro ao carregar templates</option>';
      console.error(e);
    }
  }
}
